import { PaginatedResponse as ApiPaginatedResponse } from '../models';

export interface PaginatedResponse<T> {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  items: T[];
}

export function toPaginatedResponse<T>(apiResponse: ApiPaginatedResponse): PaginatedResponse<T> {
  return {
    total: apiResponse.total,
    page: apiResponse.page,
    limit: apiResponse.limit,
    totalPages: apiResponse.totalPages,
    items: apiResponse.items as unknown as T[]
  };
}

